export function generateFilename(prefix: string, extension: string): string {
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  return `${prefix}-${timestamp}.${extension}`;
}

/** Captured media state containing preview data and file. */
export interface CapturedMedia {
  type: "photo" | "video" | "audio";
  url: string;
  file: File;
}
